import { Component, OnInit, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { featureMaster } from 'src/app/Models/BasicForms/featureMaster';
import { ApiService } from 'src/app/Service/api.service';
import { FeatureViewComponent } from '../../ModuleFeatureView/feature-view/feature-view.component';
import { FeatureMappingComponent } from '../feature-mapping/feature-mapping.component';

@Component({
  selector: 'app-feature-master',
  templateUrl: './feature-master.component.html',
  styleUrls: ['./feature-master.component.css']
})
export class FeatureMasterComponent implements OnInit {

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService) { }

  formTitle = "Features";

  ngOnInit(): void {
    this.filterIsAppliedOrNot();
    this.loadAllModules();

    this.logtext = 'OPENED - Feature Master form KEYWORD[O - Feature Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  roadmaptrue:boolean=false

  moduleID = [];
  moduleList = [];
  loadAllModules() {
    this._apiService.getAllModules(0, 0, 'ID', 'desc', '').subscribe(clientData => {
      this.moduleList = clientData['data'];

    }, err => {

    });
  }

  displayFilterBox = false;
  flterBoxVisibleInvisible() {
    this.displayFilterBox = !this.displayFilterBox;
  }

  filterButtonType = "default";
  filterIsAppliedOrNot() {
    if (this.moduleID.length > 0) {

      this.filterButtonType = "primary";

    } else {
      this.filterButtonType = "default";
    }
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["MODULE_NAME", "Module"], ["NAME", "Feature"], ["DESCRIPTION", "Description"], ["ESTIMATED_MANDAYS", "E Mandays"]];
  filterQuery: string = "";
  isloadSpinning = false;
  loadingRecords = false;
  featureData = [];

  getAllFeatures(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
      this.logtext = 'Filter Applied - Feature Master form"+ sort +" "+this.sortKey +" KEYWORD [F - Feature Master] ';
      this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
        if (successCode['code'] == "200") {

        }
        else {

        }
      });
    } catch (error) {
      sort = "";
    }


    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)

    }

    this.logtext = 'Filter Applied - Feature Master form "+ likeQuery +" KEYWORD [F - Feature Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });

    this.applyFilter();
    var filter = ""
    if (likeQuery)
      filter = this.filterQuery + likeQuery
    else
      filter = this.filterQuery


    this.isloadSpinning = true

    this._apiService.getAllFeatures(this.pageIndex, this.pageSize, this.sortKey, sort, filter).subscribe(data => {

      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.featureData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";
  applyFilter() {



    if (this.moduleID.length == 0)
      this.filterQuery = ""
    else {
      this.filterQuery = " AND MODULE_ID in ( " + this.moduleID + " )"
      this.isFilterApplied = "primary";
      this.filterClass = "filter-invisible";
    }
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";
    this.moduleID = [];

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.getAllFeatures();
  }

  drawerVisible = false;
  mappingDrawerVisible = false;
  drawerTitle = "";
  mappingDrawerTitle = "";
  featureDrawerData: featureMaster = new featureMaster();
  showWorkLogsLink = false;
  add() {
    this.drawerTitle = "Create Feature";
    this.featureDrawerData = new featureMaster();
    this.drawerVisible = true;
    this.showWorkLogsLink = false;
    this.featureDrawerData.IS_ACTIVE = true;

    this.logtext = 'ADD - Feature Master form KEYWORD [A - Feature Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  edit(data: featureMaster) {
    this.drawerTitle = "Feature Details";
    this.featureDrawerData = Object.assign({}, data);
    this.drawerVisible = true;
    this.showWorkLogsLink = true;

    this.logtext = 'EDIT - Feature Master form KEYWORD [E - Feature Master] ';
    this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
      if (successCode['code'] == "200") {

      }
      else {

      }
    });
  }

  drawerClose() {
    this.getAllFeatures();
    this.drawerVisible = false;
    this.showWorkLogsLink = null;
  }

  get callBackDrawerClose() {
    return this.drawerClose.bind(this);
  }

  mappingDrawerClose() {
    this.mappingDrawerVisible = false;
  }

  get callBackMappingDrawerClose() {
    return this.mappingDrawerClose.bind(this);
  }

  featureMappingDrawerData: [];
  @ViewChild(FeatureMappingComponent) FeatureMappingComponentVar: FeatureMappingComponent;

  mapFeature(data: featureMaster) {
    this.FeatureMappingComponentVar.loadingRecords = true;

    this._apiService.getFeatureDetails(data.ID, 1).subscribe(data => {
      this.FeatureMappingComponentVar.loadingRecords = false;

      this.featureMappingDrawerData = data['data'];

    }, err => {

    });

    this.featureDrawerData = Object.assign({}, data);
    this.mappingDrawerTitle = data.NAME;
    this.mappingDrawerVisible = true;
    this.FeatureMappingComponentVar.TASK_CATEGORY_ID = 1;
  }

  sortKey: string = "id";
  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'desc';



    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;
    this.getAllFeatures();
  }

  viewFeatureDrawerVisible = false;
  viewFeatureDrawerTitle = "";
  type: number;
  typeID: number;
  @ViewChild(FeatureViewComponent) FeatureViewComponentVar: FeatureViewComponent;

  viewFeatureDetails(data: featureMaster) {
    this.viewFeatureDrawerTitle = "Feature Details";
    this.featureDrawerData = Object.assign({}, data);
    this.viewFeatureDrawerVisible = true;

    this.type = 3;
    this.typeID = data.ID;

    this.FeatureViewComponentVar.getAttachmentIDWise(this.type, data.ID);
    this.FeatureViewComponentVar.getCommentIDWise(this.type, data.ID);
    this.FeatureViewComponentVar.getWorklogIDWise(this.type, data.ID);
    this.FeatureViewComponentVar.getAssignees(data['ASSIGNEE_NAMES']);
    this.FeatureViewComponentVar.getReporterFromID(data['REPORTER_IDS']);
  }

  viewFeatureDetailsDrawerClose() {
    this.getAllFeatures();
    this.viewFeatureDrawerVisible = false;
  }

  onEnterKeyDown() {
    document.getElementById("button1").focus();
    this.getAllFeatures(true);
  }
}
